<template>
    <div class="item-service" v-if="show">
        <ul>
            <li>
                <div class="has-icon add-icon add-transfer-night d-flex justify-content-between">
                    <div>
                        <p>Notte in transito</p>
                        <small>check-{{isCheckOut? 'out' : 'in'}}</small>
                    </div>
                    <div class="tools">
                        <button class="btn info" @click="onClickInfo(item)">
                            <div></div>
                        </button>
                    </div>
                </div>
            </li>
        </ul>
    </div>
</template>

<script>
import {mapGetters} from 'vuex'
import {isSameDate} from '../../../../utils/helper'

export default {
  name: 'ItemTransferNight',
  props: {
    day: {
      type: Date,
      default: new Date()
    }
  },
  data () {
    return {
      value: {
        groups: []
      }
    }
  },
  computed: {
    dayPlusOne () {
      return this.$moment(this.item.groups[0].dateSelected).add('days', 1).toDate()
    },
    isCheckOut () {
      return isSameDate(this.dayPlusOne, this.day)
    },
    show () {
      return this.item && this.item.groups && this.item.groups[0] && (isSameDate(this.item.groups[0].dateSelected, this.day) || this.isCheckOut)
    },
    item () {
      return this.getFlightArrivalServiceTransfer()
    }
  },
  methods: {
    ...mapGetters(['getFlightArrivalServiceTransfer']),
    isSameDate,
    onClickInfo (item) {
      this.$emit('detail', item)
    },
    onChangeGroup (groups) {
      this.groupsSelected = groups
      const payload = {...this.value, groups: [...this.groupsSelected]}
      this.addReplaceServizio(payload)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/front/components/widgets/common/itinerario/ItemTransferNight.vue